<template>
	<modal-box @close="close" :header="$t(`buttons.actions.${params.action}_insurance`)" :subHeader="$t('headers.general.watch_profile')" class="watch-profile-insurance-form">
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="model.data.name" name="insurance_name" :placeholder="$t('labels.general.name')" rules="required"/>
			<input-text v-model="model.data.number" name="insurance_number" :placeholder="$t('labels.general.number')" rules="required"/>
			<input-date v-model="model.data.expire_date" name="insurance_expire_date" :placeholder="$t('labels.general.expire_date')" rules="required"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
export default {
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			model: new ApiObject(),
			form: {
				loading: false,
				error: ''
			}
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addInsurance()
					break
				case 'edit':
					this.editInsurance()
					break
				default:
					this.$log.warn('watch profile insurance form', 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getInsurance () {
			this.model.loading = true
			this.$api.profile.insurances.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info('watch profile insurance form', 'profile.insurances.get OK', response)()
					this.model.data = response.body
				}).catch(error => {
					this.$log.error('watch profile insurance form', 'profile.insurances.get ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		addInsurance () {
			this.form.loading = true
			this.$api.profile.insurances.add(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile insurance form', 'profile.insurances.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile insurance form', 'profile.insurances.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		editInsurance () {
			this.form.loading = true
			this.$api.profile.insurances.edit(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile insurance form', 'profile.insurances.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile insurance form', 'profile.insurances.edit ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		}
	},
	created () {
		switch (this.params.action) {
			case 'add':
				this.model.data = {
					name: '',
					number: '',
					expire_date: ''
				}
				break
			case 'edit':
				this.getInsurance()
				break
			default:
				this.$log.warn('watch profile insurance form', 'action not set')()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/profile/InsuranceForm.vue